import React from "react";
import { NavLink } from "react-router-dom";
import "./NavCompactItem.css";

export default function NavCompactItem() {
  /*
          <p className="compact-nav-title">{props.title}</p>

  */

  const navitems = [
    {
      title: "Committee",
      items: [
        {
          title: "Organisation Committee",
          url: "/organisationcommittee",
        },
        {
          title: "Technical Programme Committee",
          url: "/technicalcommittee",
        },
      ],
    },
    {
      title: "Calls",
      items: [
        {
          title: "Call for Research Papers",
          url: "/researchcalls",
        },
        {
          title: "Call for Industry Papers",
          url: "/industrycalls",
        },
        { title: "Call for Posters/Demos", url: "/postercalls" },
        {
          title: "Call for Workshop Papers",
          url: "/workpapercalls",
        },
        {
          title: "Call for Workshop Proposals",
          url: "/workproposalcalls",
        },
        {
          title: "Call for PhD Forum",
          url: "/phdforumcalls",
        },
        {
          title: "Call for Tutorials",
          url: "/tutorialcalls",
        },
      ],
    },
    {
      title: "Program",
      items: [
        { title: "Accepted Papers", url: "/inprogress" },
        { title: "Schedule/Program", url: "/inprogress" },
        { title: "Keynotes", url: "/keynotes" },
        { title: "Panel", url: "/inprogress" },
        {
          title: "Poster/Demo/PhD Forum",
          url: "/inprogress",
        },
        {
          title: "Tutorials",
          url: "/inprogress",
        },
      ],
    },
    {
      title: "Workshops",
      items: [{ title: "Workshops", url: "/workshops" }],
    },
    {
      title: "Attending",
      items: [
        { title: "Camera Ready", url: "/cameraready" },
        {
          title: "Registration",
          url: "/registration",
        },
        { title: "VISA", url: "/visa" },
        {
          title: "Venue",
          url: "/venue",
        },
        {
          title: "Directions",
          url: "/inprogress",
        },
        {
          title: "Accommodation",
          url: "/accommodation",
        },

        {
          title: "NSF Student Travel Grant",
          url: "/nsfgrant",
        },
      ],
    },
    {
      title: "Previous Years",
      items: [
        { title: "SmartComp 2024", url: "https://smartcomp.w.waseda.jp/" },
        {
          title: "SmartComp 2023",
          url: "https://smartcomp.isis.vanderbilt.edu/",
        },
        { title: "SmartComp 2022", url: "https://smartcomp.aalto.fi/" },
        { title: "SmartComp 2021", url: "https://smartcomp2021.weebly.com/" },
        {
          title: "SmartComp 2020",
          url: "https://smartcomp2020.weebly.com/home.html",
        },
      ],
    },
  ];

  return (
    <div className="compact-nav">
      <p className="compact-nav-title">{navitems[0].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[0].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>
      <p className="compact-nav-title">{navitems[1].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[1].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>{" "}
      <p className="compact-nav-title">{navitems[2].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[2].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>
      <p className="compact-nav-title">{navitems[3].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[3].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>
      <p className="compact-nav-title">{navitems[4].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[4].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>
      <p className="compact-nav-title">{navitems[5].title}</p>
      <ul className="compact-nav-list">
        <nav>
          {navitems[5].items.map(function (data) {
            return (
              <li>
                {console.log(data.title)}
                <NavLink to={data.url}>{data.title}</NavLink>
              </li>
            );
          })}
        </nav>
      </ul>
    </div>
  );
}
